import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { rankWith, scopeEndsWith } from '@jsonforms/core';
import { Box, Fab } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';


function FileField(props) {
  const { id, label, handleChange, path } = props;
  const [selectedFileName, setSelectedFileName] = useState(undefined);
  const { isDragActive, getRootProps, getInputProps, inputRef } = useDropzone(
    {
      multiple: false,
      maxFiles: 1,
      onDropAccepted(files) {
        setSelectedFileName(files[0].name);
        handleChange(path, files[0]);
      }
    }
  );


  const handleRemove = () => {
    handleChange(path, undefined);
    setSelectedFileName(undefined);
  };

  return (
    <>
      <Box {...getRootProps()} style={{ height: '100px', width: '100%', borderRadius: '20px', border: '2px solid', borderColor: isDragActive ? '#00AB55' : '#ddd', borderStyle: 'dashed', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', position: 'relative' }} >
        <input id={id} {...getInputProps()}/>
        {selectedFileName !== undefined ? <p>{selectedFileName}</p> : <p>Wybierz plik</p>}
        {selectedFileName !== undefined ? <Fab size="small" color="error" style={{ position: 'absolute', top: '-12px', right: '-12px' }} onClick={e => {
          e.stopPropagation();
          handleRemove();
        }}>
          <DeleteIcon />
        </Fab> : null}
      </Box>

    </>
  );
}

export default withJsonFormsControlProps(FileField);


export const FileFieldTester = rankWith(1000, scopeEndsWith('_file'));
